import Component, {ComponentAttrs} from 'flarum/common/Component';
import Mithril from 'mithril';
import classList from 'flarum/common/utils/classList';

export interface UnreadBadgeAttrs extends ComponentAttrs {
    count: number;
    maxCount?: number;
    className?: string;
    showZero?: boolean;
}

/**
 * 通用的未读数组件，以括号形式显示未读数量
 */
export default class UnreadBadge extends Component<UnreadBadgeAttrs> {
    view() {
        const {
            count,
            maxCount = 99,
            className,
            showZero = false,
        } = this.attrs;

        if (count === 0 && !showZero) {
            return null;
        }

        const display = typeof count === 'number' && count > maxCount ? `${maxCount}+` : count;

        return (
            <span
                className={classList(
                    'UnreadCount',
                    className
                )}
                style={{
                    color: '#111',
                    fontSize: 'inherit',
                    fontWeight: 'bold'
                }}
            >
               &nbsp;({display})
            </span>
        );
    }
}
